export default __webpack_public_path__ + "static/media/AppraisalCardSorting.e3d3f084.jpg";